export const info_pedido_geral = {
  idfornecedor: 999999999,
  idfornecedor_produtos_combiados: -1,
  filial: 0
}
